import React from 'react';
export const TARGET_KIND_LABELS = {
    PROFILE: 'Profile',
    MEMBERSHIP: 'Membership',
    MEMBERSHIP_ADMIN: 'Membership Admin',
    PROSPECT: 'Prospect'
};
export const TARGET_KINDS = [
    'PROFILE',
    'MEMBERSHIP',
    'MEMBERSHIP_ADMIN',
    'PROSPECT'
];
export const segmentInputStyle = {
    padding: '0.6rem 1rem',
    fontSize: '1.3rem',
    border: '1px solid #ccc',
    borderRadius: '0.4rem'
};
export const segmentLabelStyle = {
    fontSize: '1.2rem',
    fontWeight: 600,
    marginBottom: '0.4rem',
    display: 'block'
};
export const segmentButtonStyle = {
    padding: '0.8rem 1.6rem',
    fontSize: '1.3rem',
    borderRadius: '0.4rem',
    border: 'none',
    cursor: 'pointer',
    fontWeight: 600
};
export const segmentPrimaryButtonStyle = {
    ...segmentButtonStyle,
    backgroundColor: '#f26c3a',
    color: '#fff'
};
export const segmentSecondaryButtonStyle = {
    ...segmentButtonStyle,
    backgroundColor: '#e0e0e0',
    color: '#333'
};
export const InertContainer = ({ disabled, ...props }) => {
    const divProps = {
        ...props,
        'aria-disabled': disabled || undefined,
        ...(disabled && { inert: '' })
    };
    return React.createElement('div', divProps);
};
